export default (theme) => ({
  card: {
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',

    '& .MuiCardContent-root': {
      height: '100%',
      minHeight: 285,
      padding: '34px 45px',
      gap: 23,

      '&:last-child': {
        paddingBottom: '34px',
      },

      [theme.breakpoints.up(768)]: {
        minHeight: 245,
      },

      [theme.breakpoints.up(1300)]: {
        minHeight: 245,
      },
    },
  },
  title: {
    color: '#49454F',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
    letterSpacing: '0.5px',
    textAlign: 'center',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 24,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 23,
  },
});
